import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import * as React from 'react'

export const EmptyNumber: React.VFC = () => (
  <span
    data-test-id="empty-number"
    css={css`
      color: ${colors.black30};
      padding-right: 40px;

      &:after {
        content: '-';
      }
    `}
  />
)
